export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('hubble', {
    mounted(el, binding) {
      const val = binding.value;

      el.setAttribute('data-hubble', val);
    },
  });
});
